<div>
  <app-page-breadcrumb pageTitle="Invoices" />
  <div class="flex flex-col h-full gap-6 sm:gap-5 xl:flex-row">
    <!-- Invoice Sidebar Start -->
    <app-invoice-sidebar class="rounded-2xl border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-white/[0.03] xl:w-1/5" />
    <!-- Invoice Sidebar End -->
  
    <!-- Invoice Mainbox Start -->
    <app-invoice-main class="rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] xl:w-4/5" />
    <!-- Invoice Mainbox End -->
  </div>
</div>